<mat-toolbar class="p-0 mat-elevation-z1">
    <mat-progress-bar *ngIf="showLoadingBar" class="orange-progress-bar loading-bar" color="orange"
        mode="indeterminate"></mat-progress-bar>

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <!-- @if (showToolbar) { -->
            <button mat-button class="toggle-button-navbar mat-icon-button" wtfNavbarVertical="toggleBar" fxHide.gt-md>
                <mat-icon class="icon-size">menu</mat-icon>
            </button>

            <!-- } -->

            <!-- <wtf-navbar-horizontal></wtf-navbar-horizontal> -->

            <div class="toolbar-separator" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNav">
                <div style="cursor: pointer" class="logo ms-16">
                    <img [routerLink]="['/webhome']" class="logo-icon"
                        src="../../../../assets/images/logos/logo-link-blue.png" />
                </div>
            </div>

            <div class="px-8 px-mat-16">
                <!--  <wtf-shortcuts></wtf-shortcuts> -->
            </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center">
            <div class="language-select-container" fxLayoutAlign="center center">
                <mat-select class="language-button" [panelWidth]="''" placeholder="Language"
                    (valueChange)="changeLanguage($event)" [(value)]="lang">
                    <mat-option style="
                            font-size: 16px;
                            font-family: DIN Next LT Pro, Medium !important;
                            color: #000000 !important;
                        " value="en">English</mat-option>
                    <mat-option style="
                            font-size: 16px;
                            font-family: DIN Next LT Pro, Medium !important;
                            color: #000000;
                        " value="es">Español</mat-option>
                </mat-select>
            </div>

            <div class="toolbar-separator"></div>

            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row">
                    <!-- <img class="avatar" [src]="avatarUrl"> -->
                    <div fxLayoutAlign="center center" class="user-toolbar-info">
                        <img class="avatar-icon" [src]="avatarUrl"
                            onerror="this.src='../assets/new-image/icons/Icon.svg'" />
                        <!-- <img class="avatar" [src]="((ods.loggedUser | async).avatarUrl) | image"> -->
                        <span class="username mt-4 mr-12" fxHide fxShow.gt-sm>{{
                            fullName
                            }}</span>
                        <mat-icon style="color: #000000" class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                    </div>
                </div>
            </button>

            <mat-menu #userMenu="matMenu">
                <button mat-menu-item (click)="myCompany()">
                    <mat-icon>account_circle</mat-icon>
                    <span>{{ "Mi compañía" | translate }}</span>
                </button>

                <button mat-menu-item class="" (click)="changePassword()">
                    <mat-icon>key</mat-icon>
                    <span>{{"Change Password" | translate}}</span>
                </button>

                <button mat-menu-item (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>{{ "Salir" | translate }}</span>
                </button>
            </mat-menu>

            <!--  <wtf-search-bar (onInput)="search($event)"></wtf-search-bar>

        ->  <div class="toolbar-separator"></div>

            <button mat-button fxHide fxShow.gt-xs class="language-button" [matMenuTriggerFor]="languageMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/images/flags/'+selectedLanguage.flag+'.png'">
                    <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
                </div>
            </button>

            <mat-menu #languageMenu="matMenu">

                <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <img class="flag mr-16" [src]="'assets/images/flags/'+lang.flag+'.png'">
                        <span class="iso">{{lang.title}}</span>
                    </div>
                </button>

            </mat-menu> -->

            <!--   <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="mat-icon-button quick-panel-toggle-button" wtfMatSidenavToggler="quick-panel" aria-label="Toggle quick panel">
                <mat-icon class="icon">format_list_bulleted</mat-icon>
            </button> -->
        </div>
    </div>
</mat-toolbar>